var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1077_528-614365)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1077_528-413578",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 59,
    height: 57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9661 28.2702C57.9661 12.6672 44.9899 0.0183997 28.983 0.0183997C12.9761 0.0183997 -0.00012207 12.6672 -0.00012207 28.2702C-0.00012207 43.8732 12.9761 56.522 28.983 56.522C44.9899 56.522 57.9661 43.8732 57.9661 28.2702Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1077_528-413578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4739 48.238C60.7926 37.2048 60.7926 19.3166 49.4739 8.28352C38.1551 -2.7496 19.8039 -2.7496 8.48514 8.28352C-2.83358 19.3166 -2.83358 37.2049 8.48514 48.238C19.8039 59.2711 38.1551 59.2711 49.4739 48.238Z",
    fill: "#292727"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1077_528-283862",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 59,
    height: 57
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4739 48.2385C60.7926 37.2053 60.7926 19.3171 49.4739 8.28401C38.1551 -2.74911 19.8039 -2.74911 8.48514 8.28401C-2.83358 19.3171 -2.83358 37.2053 8.48514 48.2385C19.8039 59.2716 38.1551 59.2716 49.4739 48.2385Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1077_528-283862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4152 52.9711C49.4152 59.6655 8.58472 59.6655 8.58472 52.9711C8.58472 46.2766 24.7119 43.6455 28.9829 43.6455C33.288 43.6788 49.4152 46.2766 49.4152 52.9711Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9829 47.1093C27.0011 47.1093 25.3611 45.5439 25.3611 43.5789V35.5522H32.6047V43.5789C32.6047 45.5439 30.9988 47.1093 28.9829 47.1093Z",
    fill: "#ED9F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6047 41.5143V38.4502H25.3611V41.5143C26.4886 41.9473 27.6845 42.2137 28.9829 42.2137C30.2812 42.2137 31.4771 41.9806 32.6047 41.5143Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9828 39.9152C23.6527 39.9152 19.3475 35.7187 19.3475 30.523V23.0626C19.3475 17.8669 23.6527 13.6704 28.9828 13.6704C34.313 13.6704 38.6182 17.8669 38.6182 23.0626V30.523C38.6182 35.7187 34.313 39.9152 28.9828 39.9152Z",
    fill: "#ED9F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3909 32.0553C19.8439 32.0553 21.0218 30.9072 21.0218 29.4908C21.0218 28.0744 19.8439 26.9263 18.3909 26.9263C16.9379 26.9263 15.7599 28.0744 15.7599 29.4908C15.7599 30.9072 16.9379 32.0553 18.3909 32.0553Z",
    fill: "#ED9F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5117 29.6575C16.4092 29.6575 16.3408 29.5909 16.3408 29.491C16.3408 28.3919 17.2633 27.4927 18.3909 27.4927C18.4934 27.4927 18.5617 27.5593 18.5617 27.6592C18.5617 27.7591 18.4934 27.8257 18.3909 27.8257C17.4342 27.8257 16.6825 28.5585 16.6825 29.491C16.6825 29.5909 16.58 29.6575 16.5117 29.6575Z",
    fill: "#DF4B27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.609 32.0553C41.062 32.0553 42.2399 30.9072 42.2399 29.4908C42.2399 28.0744 41.062 26.9263 39.609 26.9263C38.156 26.9263 36.9781 28.0744 36.9781 29.4908C36.9781 30.9072 38.156 32.0553 39.609 32.0553Z",
    fill: "#ED9F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4883 29.6575C41.3858 29.6575 41.3175 29.5909 41.3175 29.491C41.3175 28.5585 40.5658 27.8257 39.6091 27.8257C39.5066 27.8257 39.4382 27.7591 39.4382 27.6592C39.4382 27.5593 39.5066 27.4927 39.6091 27.4927C40.7366 27.4927 41.6591 28.3919 41.6591 29.491C41.6591 29.5909 41.5908 29.6575 41.4883 29.6575Z",
    fill: "#DF4B27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6185 16.768C23.6185 16.768 26.0444 23.4957 38.9598 23.4957C39.0965 23.4957 39.2332 23.3958 39.3357 23.1626V23.0627C39.3357 17.4008 34.518 12.8379 28.7095 13.0044C26.6936 13.071 24.8144 13.7038 23.2427 14.7696C18.8692 15.136 18.6984 19.7988 18.6984 23.2958V24.0952C18.6984 24.3616 19.0059 24.5615 19.2792 24.3949C20.4751 23.6955 23.311 21.5307 23.6185 16.768Z",
    fill: "#DF4B27"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1077_528-614365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon_avatar.da8b5e8678e2fd7d68406a6ccf312235.svg";
export { ForwardRef as ReactComponent };